import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Timer from "./Timer";
import { useSendOtpCodeMutation } from "../../../../Store/Slices/rtk";
import { useDispatch, useSelector } from "react-redux";
import { setAuthData } from "../../../../Store/Slices/reducer";

export default function TimeRemaining({ send, setSend }) {
  const dispatch = useDispatch();
  const [time, setTime] = useState(60);
  const theme = useTheme();
  const phoneNumber = useSelector((state) => state.authSlice.phoneNumber);
  const [sendOtpCode, { isLoading, data }] = useSendOtpCodeMutation();

  useEffect(() => {
    const tmpToken = data?.tmp_token;
    dispatch(
      setAuthData({
        phoneNumber: phoneNumber,
        tempToken: tmpToken,
      })
    );
  }, [data]);

  const handleResend = () => {
    sendOtpCode(phoneNumber);
    setTime(60);
  };
  return (
    <>
      <Stack
        direction={"row-reverse"}
        alignItems={"center"}
        justifyContent="center"
        sx={{
          width: "100%",
          direction: "rtl",
          gap: "5px",
          color: theme.palette.primary.main,
        }}
      >
        {/* title */}
        <Typography component={"body1"} sx={{}}>
          مانده تا دریافت مجدد کد
        </Typography>
        {/* timer second */}
        {time == 0 ? (
          <Button
            onClick={() => handleResend()}
            variant="text"
            sx={{
              color: theme.palette.primary.main,
              fontSize: "1rem",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            ارسال مجدد کد
          </Button>
        ) : (
          <Typography>
            <Timer
              send={send}
              setSend={setSend}
              time={time}
              setTime={setTime}
            />
          </Typography>
        )}
      </Stack>
    </>
  );
}
